export const getApiUrl = () => {
  return window.location.origin;
};
